import { SlideOverPanel } from '@/components/admin/shared/SlideOverPanel';
import { FrameworkApprovalsTab } from './FrameworkApprovalsTab';

interface ApprovalsSidePanelProps {
  isOpen: boolean;
  onClose: () => void;
}

export function ApprovalsSidePanel({ isOpen, onClose }: ApprovalsSidePanelProps) {
  return (
    <SlideOverPanel isOpen={isOpen} onClose={onClose} title="Approvals" width="max-w-2xl">
      <div className="p-5">
        <FrameworkApprovalsTab />
      </div>
    </SlideOverPanel>
  );
}
